export default {
  name: 'transaction_customer_lastname',
  component_path: 'modules/procedures/blocks/BlockInputText',
  static_mandatory: ['required'],
  static_options: {
    autocomplete: 'family-name'
  }
}